import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_ConsentForTreatment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_ConsentForTreatment' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    I/We hereby give consent for mental health treatment (which may include services, supports) for the above-named
                    Consumer. Services may include one or more of the following: <br />
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_1' name='cbhealthtreatment_1' className='add-only' value='Anger' />Diagnostic Evaluation and Diagnostic Evaluation Update 
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_2' name='cbhealthtreatment_2' className='add-only' value='Anger' /> Community Psychiatric Service Treatment (CPST) 
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_3' name='cbhealthtreatment_3' className='add-only' value='Anger' />Psychotherapy (Individual, Family, Group, Crisis)
                </p>
                <p className='w-750'> <input type='checkbox' id='cbhealthtreatment_4' name='cbhealthtreatment_4' className='add-only' value='Anger' />Psychoeducation Support Services (Therapeutic Behavioral Services, Psychosocial Rehabilitation)
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_5' name='cbhealthtreatment_5' className='add-only' value='Anger' />Assertive Community Treatment (ACT) 
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_6' name='cbhealthtreatment_6' className='add-only' value='Anger' />Intensive Home-Based Therapy (IHBT)
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_7' name='cbhealthtreatment_7' className='add-only' value='Anger' /> Substance Use Disorder Assessment and ASAM Level of Care
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_8' name='cbhealthtreatment_8' className='add-only' value='Anger' />Substance Use Disorder Services (Case Management; Psychotherapy; Individual Counseling; Group)<br />
                </p>
                <p className='w-750'> <input type='checkbox' id='cbhealthtreatment_9' name='cbhealthtreatment_9' className='add-only' value='Anger' />Intensive Outpatient Treatment
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_10' name='cbhealthtreatment_10' className='add-only' value='Anger' />Laboratory Analysis
                </p>
                <p className='w-750'><input type='checkbox' id='cbhealthtreatment_11' name='cbhealthtreatment_11' className='add-only' value='Anger' />Medication Management</p>

                <p className='w-750'>
                    I understand that all information shared with service providers at Life Solutions South is confidential and no information will
                    be released without my consent. During the course of treatment at Life Solutions South, it may be necessary for my service
                    provider to communicate with providers at <b>Life Solutions South</b>. While written authorization will not be requested, prior to
                    any discussion with <b>Life Solutions South</b> providers, I understand that only provider will discuss all communications with me.
                    In all other circumstances, consent to release information is given through written authorization. Verbal consent for limited
                    release of information may be necessary in special circumstances. I further understand that there are specific and limited
                    exceptions to this confidentiality which include the following:<br /> <br />
                    <b>A.</b>  When there is risk of imminent danger to myself or to another person, the service provider is ethically bound to
                    take necessary steps to prevent such danger.<br />
                    <b> B.</b> When there is suspicion that a child or elder is being sexually or physically abused or is at risk of such abuse, the
                    provider is legally required to take steps to protect the child and to inform the proper authorities.<br />
                    <b> C.</b> When a valid court order is issued for medical records, the provider and the agency are bound by law to comply
                    with such requests. <br /> <br />
                    If I have any questions regarding this consent form or about the services offered at <b>Life Solutions South</b>, I may discuss them
                    with my provider or the Clinical Supervisor. I have read and understand the above. I consent to receive the treatment
                    offered to me by <b>Life Solutions South</b>. I understand that I may stop treatment at any time. <br /> <br />

                    <b>The consent/or treatment process has been thoroughly explained to me and I understand that I may stop treatment at any time. </b>
                </p>


                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client Name (Printed): </td>
                        <td className='small w-375'>Client Signature:</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Parent/Legal Guardian Signature:</td>
                        <td className='small w-375'>Date:</td>
                    </tr>
                </table>






            </div>
        </form >

    )
}